<template>
  <div>
    <v-btn x-small class="v-warning" @click="visible = true">
      NÃO SEI MEU CEP
    </v-btn>
    <b-modal
      v-model="visible"
      hide-footer
      no-close-on-backdrop
      size="lg"
      title="BUSCAR CEP"
      @show="evOnShow"
      @shown="evOnShown"
      @hide="evOnHide"
    >
      <b-overlay :show="loading">
        <b-form v-if="step === 'search'" @submit.prevent="evOnSubmit">
          <b-row>
            <b-col>
              <label for="address">RUA/AVENIDA</label>
              <b-input ref="autofocus" id="address" v-model="address"></b-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <label for="city">CIDADE</label>
              <b-input id="city" v-model="city"></b-input>
            </b-col>
            <b-col>
              <label for="uf">ESTADO</label>
              <b-select id="uf" v-model="uf">
                <b-select-option value>SELECIONE</b-select-option>
                <b-select-option
                  v-for="uf in ufs"
                  :key="uf.id"
                  :value="uf.initials"
                >
                  {{ uf.name }}
                </b-select-option>
              </b-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div v-if="ceps.length == 0" class="v-clean p-5 text-center">
                Sem resultados!
              </div>
              <v-data-table
                v-if="ceps.length > 0"
                :items="ceps"
                :headers="headers"
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn
                    small
                    class="btn-edit m-1"
                    @click="evOnCEPSelected(item)"
                  >
                    <i class="fas fa-pen mr-2 text-twenty"></i>
                    SELECIONAR
                  </v-btn>
                </template>
              </v-data-table>
            </b-col>
          </b-row>
          <b-row align-h="end">
            <b-col cols="auto">
              <v-btn type="submit" :disabled="loading" class="btn-add">
                <i class="fas fa-search mr-2 text-twenty"></i> BUSCAR
              </v-btn>
            </b-col>
          </b-row>
        </b-form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import api from "../../services/api";
import apiCep from "../../services/apiCep";

export default {
  name: "SearchCEP",

  data() {
    return {
      errors: [],
      visible: false,
      loading: false,

      /** @type {("search"|"select")} */
      step: "search",

      ufs: [],

      uf: "",
      city: "",
      address: "",

      headers: [
        { text: "LOGRADOURO", value: "logradouro" },
        { text: "CEP", value: "cep" },
        { text: "AÇÕES", value: "actions" },
      ],
      ceps: [],
    };
  },

  created() {
    this.retrieve();
  },

  computed: {
    searchURL() {
      const uf = encodeURI(this.uf.toUpperCase());
      const city = encodeURI(this.city.toUpperCase());
      const address = encodeURI(this.address.toUpperCase());
      return `/${uf}/${city}/${address}/json`;
    },
  },

  methods: {
    async retrieve() {
      if (this.errors.length === 0) this.getUFs();
    },

    async evOnShow() {
      this.step = "search";

      this.uf = "";
      this.city = "";
      this.address = "";
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnHide() {},

    async getUFs() {
      try {
        this.loading = true;

        const response = await api.get("/ufs");
        const { error, errors, ufs } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.ufs = ufs;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        this.errors = [];

        if (this.address.length === 0) this.errors.push("");
        if (this.city.length === 0) this.errors.push("INFORME A CIDADE");
        if (this.uf.length === 0) this.errors.push("INFORME O ESTADO");
        if (this.errors.length > 0) return;

        const response = await apiCep.get(this.searchURL);
        this.ceps = response.data;

        if (this.ceps.length === 0)
          this.errors.push(
            "NENHUM RESULTADO ENCONTRADO, VERIFIQUE OS CAMPOS E TENTE NOVAMENTE"
          );
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    evOnCEPSelected(value) {
      this.visible = false;
      this.$emit("selected", value);
    },
  },
};
</script>

<style scoped>
small {
  cursor: pointer;
}

small:hover {
  color: var(--primary);
}

small:active {
  color: var(--cyan);
}
</style>